import React from 'react'
import { colors } from '@resurs/midas'

import { getText } from '../../../../internal/TextLabels'

const style = {
  borderTop: `3px solid ${colors.red}`,
  borderLeft: '1px solid rgba(0,0,0,0.12)',
  borderRight: '1px solid rgba(0,0,0,0.12)',
  borderBottom: '1px solid rgba(0,0,0,0.12)',
  padding: '1rem',
}
const BatchImportError = props => {
  if (props.errors) {
    const { errors, recordsImported, recordsRead } = props.errors

    if (!!errors && Array.isArray(errors)) {
      return (
        <div style={style}>
          <strong>
            {getText(
              'user.import.messages.recordsReadAndImported',
              `${recordsImported}`,
              `${recordsRead}`,
            )}
          </strong>
          <p>{getText('user.import.messages.noUsersImported')}</p>
          <ul style={{ margin: 0 }}>
            {errors.map(error => (
              <li key={error}>{error}</li>
            ))}
          </ul>
        </div>
      )
    }

    return <div style={style}>{props.errors}</div>
  }

  return null
}

export default BatchImportError
